/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForSaasGcpOauthProtocol extends models.ServiceAccountCredentialsBaseForSaasGcp {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForSaasGcpOauthProtocol");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForSaasGcpOauthProtocol.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForSaasGcpOauthProtocol>): ServiceAccountCredentialsForSaasGcpOauthProtocol {
        let obj = Object.assign(new ServiceAccountCredentialsForSaasGcpOauthProtocol(), model);
        ServiceAccountCredentialsForSaasGcpOauthProtocol.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForSaasGcpOauthProtocol>): ServiceAccountCredentialsForSaasGcpOauthProtocol {
        if (!model) return null;
        return ServiceAccountCredentialsForSaasGcpOauthProtocol.newInstance(<ServiceAccountCredentialsForSaasGcpOauthProtocol> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForSaasGcpOauthProtocol) {
        if (!obj) return;

        models.ServiceAccountCredentialsForSaasGcpOauthProtocol.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForSaasGcpOauthProtocol): boolean {
        if (models.ServiceAccountCredentialsBaseForSaasGcp.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForSaasGcpOauthProtocol.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Project Id in which the bucket exists. This is a required field.
     */
    project_id: string;

    /**
     * Client Id. This is a required field.
     */
    client_id: string;

    /**
     * Client Secret. This is a required field.
     */
    client_secret: string;

    /**
     * Redirect URI. This is a required field.
     */
    redirect_uri: string;

    /**
     * Authorization Code. This is a required field.
     */
    authorization_code: string;

}
